export const getTranslationURL = (churchID: string, serviceID: string) => {
  return `${window.location.protocol}//${window.location.host}/church/${churchID}/service/${serviceID}`;
};
